// extracted by mini-css-extract-plugin
module.exports = {"login":"Auth_login__fqvw0","Button_1":"Auth_Button_1__p3mll","Button_2":"Auth_Button_2__2XNub"};